import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#i1199892319__a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M15.618 2.426v.5h4.03c.487 0 .957.198 1.306.553.348.355.546.84.546 1.347v16.8c0 .507-.198.991-.546 1.347a1.83 1.83 0 0 1-1.307.553H4.353a1.83 1.83 0 0 1-1.307-.553l-.355.348.355-.348a1.92 1.92 0 0 1-.546-1.347v-16.8c0-.507.198-.992.546-1.347a1.83 1.83 0 0 1 1.307-.553h4.03v-.5c0-.507.197-.992.546-1.347a1.83 1.83 0 0 1 1.306-.553h3.53c.488 0 .958.198 1.307.553.348.355.546.84.546 1.347zm-1.353 0v-.5h-4.53v4.6h4.53zm3.042 10.798-.357-.35.357.35a1.713 1.713 0 0 0 0-2.397l-.358.35.358-.35a1.67 1.67 0 0 0-1.19-.501H7.883c-.448 0-.875.181-1.189.501-.313.32-.487.751-.487 1.199s.174.879.487 1.198c.314.32.741.502 1.19.502h8.235c.448 0 .875-.182 1.189-.502zm-9.425 5.302h8.236c.448 0 .875-.182 1.189-.502a1.713 1.713 0 0 0 0-2.397 1.67 1.67 0 0 0-1.19-.501H7.883c-.448 0-.875.181-1.189.501-.313.32-.487.751-.487 1.199s.174.879.487 1.198c.314.32.741.502 1.19.502z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "i1199892319__a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 .026h24v24H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }